var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMuchMore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    viewBox: "0 0 97 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6818 0H5.95455C2.94208 0 0.5 2.44208 0.5 5.45455V38.1818C0.5 41.1944 2.94208 43.6364 5.95455 43.6364H38.6818C41.6944 43.6364 44.1364 41.1944 44.1364 38.1818V5.45455C44.1364 2.44208 41.6944 0 38.6818 0Z",
    fill: "#22428F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6818 52.3638H5.95455C2.94208 52.3638 0.5 54.8058 0.5 57.8183V90.5456C0.5 93.5581 2.94208 96.0001 5.95455 96.0001H38.6818C41.6944 96.0001 44.1364 93.5581 44.1364 90.5456V57.8183C44.1364 54.8058 41.6944 52.3638 38.6818 52.3638Z",
    fill: "#22428F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0456 0H58.3183C55.3058 0 52.8638 2.44208 52.8638 5.45455V38.1818C52.8638 41.1944 55.3058 43.6364 58.3183 43.6364H91.0456C94.0581 43.6364 96.5001 41.1944 96.5001 38.1818V5.45455C96.5001 2.44208 94.0581 0 91.0456 0Z",
    fill: "#22428F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2271 52.3638H92.1361",
    stroke: "#FFD808",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6816 69.8184H92.1362",
    stroke: "#FFD808",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2271 87.2729H92.1361",
    stroke: "#FFD808",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuchMore);
export default __webpack_public_path__ + "static/media/much-more.4628feb4f9c3fbec38635d23da74da3f.svg";
export { ForwardRef as ReactComponent };